





































































import Vue from "vue";
import flowStore, { InvoiceFlowStore } from "@/modules/invoiceFlow/services/InvoiceFlowStore";
import IconButton from "@/components/IconButton.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import * as api from "@/modules/invoiceItems/services/api";
import { InvoiceItem } from "@/modules/invoiceItems/models";
import WorkSheetItemRelation from "@/modules/invoiceItemDimension/models/WorkSheetItemRelations";
import { t } from "@/plugins/i18n";

interface Data {
  flowStore: InvoiceFlowStore;
  subcontractorOrderItemRelations: any[];
  newSubcontractorOrderItemRelations: any[];
  searchText: string;
  selectedItems: any[];
}

export default Vue.extend<Data, {}, {}, {}>({
  components: { IconButton, MoneyDisplay, CheckBox },
  props: {
    invItemId: Number,
    isPageDisabled: Boolean,
    item: InvoiceItem,
  },

  data() {
    return {
      flowStore,
      subcontractorOrderItemRelations: [],
      newSubcontractorOrderItemRelations: [],
      selectedItems: [],
      searchText: "",
    }
  },

  async beforeMount() {
    this.subcontractorOrderItemRelations = await api.getCurrentOperelSubcontractorOrderItemRelations(Number(this.$props.invItemId));
  },

  methods: {
    async search(e: KeyboardEvent) {
      if (e.key != "Enter") {
        return;
      }
      this.newSubcontractorOrderItemRelations = (
        await api.searchOperelSubcontractorOrderItemRelations(
          this.searchText,
          this.flowStore.invoice.partner,
        )
      ).map((x: any) => ({ ...x, isSelected: false }));
    },

    clear() {
      this.newSubcontractorOrderItemRelations = [];
      this.searchText = "";
    },

    selectItem(item: any) {
      if (!item.isSelected) {
        item.isSelected = true;
        this.selectedItems.push(item);
      } else {
        item.isSelected = false;
        this.selectedItems = this.selectedItems.filter((x) => x.id != item.id);
      }
    },

    async addItems() {
      if (this.selectedItems.length == 0) {
        return;
      }

      const items: WorkSheetItemRelation[] = [];
      this.selectedItems.forEach((e) => {
        items.push({
          id: 1,
          invNo: Number(this.$route.params.invoiceId),
          wsCont: 1,
          itemId: Number(this.$props.invItemId),
          total: Number(e.price),
          facSheetCoop: 1,
          fachSheetBr: 1,
          operelSubcontractorItem: e.id,
          note: "",
        });
      });

      const success = await api.addOperelSubcontractorOrderItemRelation(items);
      this.newSubcontractorOrderItemRelations = [];
      this.subcontractorOrderItemRelations = await api.getCurrentOperelSubcontractorOrderItemRelations(Number(this.$props.invItemId));
      this.selectedItems = [];
    },

    async deleteItem(item: any) {
      this.subcontractorOrderItemRelations = this.subcontractorOrderItemRelations.filter((x) => x.id != item.id);
      await api.deleteWorkSheetItemRelation(item.id);
    },
  },

  computed: {
    newColumns: () => [
      { field: "head", title: t("InvoiceItems_RendelesFej") },
      { field: "orderNo", title: t("RendelesSzam") },
      { field: "name", title: t("Megnevezes") },
      { field: "statusName", title: t("Statusz") },
      { field: "expDelivDate", title: t("InvoiceItems_VarhatoSzallitas"), type: "date", format: "{0: yyyy. MM. dd.}" },
      { field: "price", title: t("InvoiceItems_AlvallalkozoiAr"), cell: "priceTemplate", headerClassName: "right_text" },
      { field: "quantity", title: t("Mennyiseg"), cell: "quantityTemplate", headerClassName: "right_text" },
      { cell: "commandTemplate", width: "60px" },
      { width: 0 },
    ],

    columns: () => [
      { field: "head", title: t("InvoiceItems_RendelesFej") },
      { field: "orderNo", title: t("RendelesSzam") },
      { field: "name", title: t("Megnevezes") },
      { field: "statusName", title: t("Statusz") },
      { field: "expDelivDate", title: t("InvoiceItems_VarhatoSzallitas"), type: "date", format: "{0: yyyy. MM. dd.}" },
      { field: "total", title: t("Total"), cell: "totalTemplate", headerClassName: "right_text" },
      { cell: "commandTemplate", width: "60px" },
      { width: 0 },
    ],
  },
})
